import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { languages } from "../../data/config";
import { ReactNode } from "react";
import { Language } from "types/models";
import { catalogService, medicalExaminationService } from "api";
import { TT_PHIEU_KHAM } from "types/enums";

type State = {
  collapsed: boolean;
  language: Language;
  buttonsHeader: ReactNode[];
  activeTab: string;
  siderKey: string;
  setLoadingInfo: boolean;
  khoUserId: number;
  idPhieuKham: number | string;
  idReceiptPrint: number | string;
  dataUser: ReactNode[];
  currentRoom: any;
  listDoiTuongKCB: any[];
  listTTKCB: any[];
  listPhong: any[];
  listPhongSider: any[];
  listThanhToan: any[];
  userRoles: string[];
  refreshCallPayroll: any;
  nextActiveTab: string;
  isModalOpen: boolean;
};

const initialState: State = {
  collapsed: false,
  language: languages[0],
  buttonsHeader: [],
  activeTab: "",
  siderKey: "",
  setLoadingInfo: null,
  khoUserId: null,
  idPhieuKham: null,
  idReceiptPrint: null,
  dataUser: [],
  currentRoom: null,
  listDoiTuongKCB: null,
  listTTKCB: [],
  listPhong: [],
  listPhongSider: [],
  listThanhToan: [],
  userRoles: [],
  refreshCallPayroll: false,
  nextActiveTab: "",
  isModalOpen: false,
};

export const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setCollapsed: (state = initialState, action: PayloadAction<any>) => {
      return { ...state, collapsed: action.payload };
    },
    setLanguage: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        language: action.payload,
      };
    },
    setButtonsHeader: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        buttonsHeader: action.payload,
      };
    },
    setActiveKey: (state = initialState, action: PayloadAction<any>) => {
      localStorage.setItem("currentTab", action.payload);
      return {
        ...state,
        activeTab: action.payload,
      };
    },
    setNextActiveKey: (state = initialState, action: PayloadAction<any>) => {
      localStorage.setItem("currentTab", action.payload);
      return {
        ...state,
        nextActiveTab: action.payload,
      };
    },
    setKhoUserId: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        khoUserId: action.payload,
      };
    },
    setIdPhieuKham: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPhieuKham: actions.payload,
      };
    },
    setIdReceiptPrint: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idReceiptPrint: actions.payload,
      };
    },
    setCurrentRoom: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        currentRoom: actions.payload,
      };
    },
    setListDoiTuongKCB: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listDoiTuongKCB: actions.payload,
      };
    },
    setListTTKCB: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listTTKCB: actions.payload,
      };
    },
    setListPhong: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listPhong: actions.payload,
      };
    },
    setListPhongSider: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listPhongSider: actions.payload,
      };
    },
    setListThanhToan: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        listThanhToan: actions.payload,
      };
    },
    setSiderKey: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        siderKey: actions.payload,
      };
    },
    setUserRoles: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        userRoles: actions.payload,
      };
    },
    setRefreshCallPayroll: (state = initialState) => {
      return {
        ...state,
        refreshCallPayroll: !state.refreshCallPayroll,
      };
    },
    setIsModalOpenRedux: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        isModalOpen: actions.payload,
      };
    },
  },
});

export const {
  setCollapsed,
  setLanguage,
  setButtonsHeader,
  setActiveKey,
  setIdPhieuKham,
  setIdReceiptPrint,
  setCurrentRoom,
  setListDoiTuongKCB,
  setListPhong,
  setListPhongSider,
  setListThanhToan,
  setSiderKey,
  setListTTKCB,
  setUserRoles,
  setRefreshCallPayroll,
  setNextActiveKey,
  setIsModalOpenRedux,
} = commonSlice.actions;
export default commonSlice.reducer;

export const getListDoiTuongAPI = () => {
  return async (dispatch) => {
    try {
      const listDoiTuongKCB = (await catalogService.getListDoiTuongKCB()) || [];
      dispatch(setListDoiTuongKCB(listDoiTuongKCB));
    } catch (error) {}
  };
};
export const getListTTKCBAPI = () => {
  return async (dispatch) => {
    try {
      const res = await medicalExaminationService.getListTTPhieuKham({
        page: 1,
        limit: 20,
      });
      const listTTKCB = res?.data || [];
      dispatch(setListTTKCB(listTTKCB));
    } catch (error) {}
  };
};

export const getListPhongAPI = () => {
  return async (dispatch) => {
    try {
      const listPhong = (await catalogService.getListPhong()) || [];

      dispatch(setListPhong(listPhong));
    } catch (error) {}
  };
};
export const getListPhongSiderAPI = () => {
  return async (dispatch) => {
    try {
      const listPhongSider = (await catalogService.getListPhong()) || [];

      dispatch(setListPhongSider(listPhongSider));
    } catch (error) {}
  };
};
